import type { Meta, StoryObj } from "@storybook/react";

import type { HelpCenterCardProps } from "@/ui/components/profile/HelpCenterCard";
import HelpCenterCard, {
  HelpCenterCardContentMap,
} from "@/ui/components/profile/HelpCenterCard";

const StoryMeta: Meta<HelpCenterCardProps> = {
  title: "Components/Profile/Help Center Card",
  component: HelpCenterCard,
  argTypes: {
    contentVariant: {
      control: "select",
      defaultValue: "default",
      description: "Variant of the Help Center Card content.",
      options: Object.keys(HelpCenterCardContentMap),
    },
    onPress: { action: "onPress" },
  },
  args: {},
};

type Story = StoryObj<HelpCenterCardProps>;

const Primary: Story = {};
const MealSupport: Story = {
  args: {
    contentVariant: "mealSupport",
  },
};

export { MealSupport, Primary };
export default StoryMeta;
